import './bootstrap';
import $ from 'jquery';
window.$ = window.jQuery = $;
import * as bootstrap from "bootstrap";
import { tns } from "tiny-slider/src/tiny-slider";
window.tns = tns;
import { entrance } from "scroll-entrance/dist/scroll-entrance";
const Cookies = require('js-cookie');
const lightbox = require('lightbox2');


import 'select2';
import 'select2/dist/js/i18n/pl';
import './script';
import './contact_form_walid';
import './walid_modalForm';
import './walid_modalTestdrive';
import './visit_service';
import './modelScript';
import './history';
import './calculatorLeasing';
import './lpg_page';
import "./submit";


